import type { Dayjs } from 'dayjs';

import { useSelectorJs } from 'utils/customHooks';

import { toUTCByTimezone, toLocalByTimezone } from '../utils/dates';
import { DATE_TIME_FORMAT } from '../constants/dates';
import { LocationsState } from '../store/slices/locationsSlice';
import { ImmutableRootState } from '../store/store';

type TimezoneDateInput = Dayjs | Date | string | null | undefined;

export const useTimezoneConverter = (locationId?: number) => {
  const locations = useSelectorJs((state: ImmutableRootState) =>
    state.getIn(['locations', 'locations']),
  ) as LocationsState['locations'];

  const globalLocation = useSelectorJs((state: ImmutableRootState) =>
    state.getIn(['locations', 'globalLocation']),
  ) as LocationsState['globalLocation'];

  const location = locationId
    ? locations.find((loc) => loc.id === locationId)
    : globalLocation;

  // Fallback: location timezone → browser timezone
  const tz =
    location?.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;

  const toUTC = (date: TimezoneDateInput) =>
    toUTCByTimezone(date, tz)?.format(DATE_TIME_FORMAT);
  const toLocal = (date: TimezoneDateInput) => toLocalByTimezone(date, tz);

  return { toUTC, toLocal, timezone: tz };
};
